import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/app/App";
import "./styles/globals.css";
import "./i18n";
import { isChunkLoadError, CHUNK_RELOAD_KEY } from "@/shared/utils/chunkLoadError";

// ---------------------------------------------------------------------------
// Global safety net for chunk-load failures that escape React's error boundary
// (e.g. dynamic imports triggered outside the React tree, or Vite's preload
// links failing before React has mounted).
// ---------------------------------------------------------------------------
window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
  if (isChunkLoadError(event.reason)) {
    const alreadyAttempted = sessionStorage.getItem(CHUNK_RELOAD_KEY);
    if (!alreadyAttempted) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
      window.location.reload();
    }
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Clear the chunk-reload circuit-breaker key once the app has successfully
// mounted. This allows a second deployment in the same session to trigger
// one fresh auto-reload if a new chunk-load error occurs.
sessionStorage.removeItem(CHUNK_RELOAD_KEY);
